/**
 * FilterPanel - Handles filter controls and ranking mode toggle
 */

import * as d3 from 'd3';
import { RankingMode } from '../types/config.types';
import { AnalyticsService } from '../services/AnalyticsService';

export class FilterPanel {
    private analytics: AnalyticsService;
    private rankingMode: RankingMode = 'cumulative';
    private onFilterChange: () => void;
    private onRankingModeChange: (mode: RankingMode) => void;

    constructor(
        analytics: AnalyticsService,
        onFilterChange: () => void,
        onRankingModeChange: (mode: RankingMode) => void
    ) {
        this.analytics = analytics;
        this.onFilterChange = onFilterChange;
        this.onRankingModeChange = onRankingModeChange;
        this.setupEventListeners();
    }

    private setupEventListeners(): void {
        // Ranking mode toggle
        d3.select('#cumulative-mode').on('click', () => {
            this.setRankingMode('cumulative');
        });

        d3.select('#individual-mode').on('click', () => {
            this.setRankingMode('individual');
        });

        // Filter dropdowns
        d3.select('#category-filter').on('change', (event) => {
            const value = (event.target as HTMLSelectElement).value;
            this.analytics.logFilterApplied('category', value);
            this.onFilterChange();
        });

        d3.select('#distance-filter').on('change', (event) => {
            const value = (event.target as HTMLSelectElement).value;
            this.analytics.logFilterApplied('distance', value);
            this.onFilterChange();
        });

        d3.select('#age-filter').on('change', (event) => {
            const value = (event.target as HTMLSelectElement).value;
            this.analytics.logFilterApplied('age_group', value);
            this.onFilterChange();
        });
    }

    private setRankingMode(mode: RankingMode): void {
        this.rankingMode = mode;

        d3.select('#cumulative-mode').classed('active', mode === 'cumulative');
        d3.select('#individual-mode').classed('active', mode === 'individual');

        this.analytics.logRankingModeChanged(mode);
        this.onRankingModeChange(mode);
    }

    getRankingMode(): RankingMode {
        return this.rankingMode;
    }
}
